module.exports = __webpack_public_path__ + "img/plant.cf5a810a.png";